<!-- =========================================================================================
    File Name: i18n.vue
    Description: I18n demo
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="mb-8">
      <div class="vx-row">
        <div class="vx-col md:w-3/4 sm:w-2/3 w-full">
          <import-excel :onSuccess="loadDataInTable" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/3 w-full">
          <card-download-template type="accounting"></card-download-template>
        </div>
      </div>
    </div>
    <vx-card v-if="state === 'list' ">
      <vs-table stripe pagination :max-items="maxItems" search :data="tableData">
        <template slot="header">
          <div class="flex">
            <vs-button color="success" class="ml-auto mx-1" @click="download('')">{{ $t("general.download") }}</vs-button>
          </div>
          <div class="flex mr-auto">
            <vs-button color="warning" type="filled" @click="submit('check')" v-if="pms ('AccountingImport', 'create', 'b') ">ตรวจสอบข้อมูล</vs-button>
          </div>
        </template>

        <template slot="thead">
          <vs-th :sort-key="heading" v-for="heading in header" :key="heading">{{ heading }}</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
            <vs-td :data="col" v-for="(col, indexCol) in data[index]" :key="indexCol + col">
              {{ col }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <vx-card v-if="state === 'checked'">
      <vs-table :data="result">
        <template slot="header">
          <div>
            <vs-button color="success" type="filled" @click="submit('import')" v-if="pms ('AccountingImport', 'create', 'b') && state === 'checked'" :disabled="result.filter(res => res.error == true).length >= 1">นำเข้าข้อมูล</vs-button>
          </div>
        </template>
        <template slot="thead">
          <vs-th>ลำดับ</vs-th>
          <vs-th>ผลการตรวจสอบ</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :state="tr.success === true ? 'success' : 'danger'" :key="index" v-for="(tr, index) in data">
            <vs-td class="w-1/12">
              {{ (index+1) }}
            </vs-td>
            <vs-td class="w-7/12">
              {{ tr.errorMassage }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <vx-card v-if="state === 'imported'">
      <vs-table :data="result">
        <template slot="header">
          <div>
            {{ $t("general.importResultTitle", {total: result.length, success: result.filter(res => res.success === true).length, error: result.filter(res => res.error === true).length}) }}
          </div>
        </template>
        <template slot="thead">
          <vs-th>ลำดับ</vs-th>
          <vs-th>ผลการนำเข้า</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :state="tr.success === true ? 'success' : 'danger'" :key="index" v-for="(tr, index) in data">
            <vs-td class="w-1/12">
              {{ (index+1) }}
            </vs-td>
            <vs-td class="w-7/12">
              {{ tr.errorMassage }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import ImportExcel from './Excel/ImportExcel.vue'
import vSelect from 'vue-select'
import { mapGetters, createNamespacedHelpers } from 'vuex'
const _ = require('lodash');
const moment = require('moment');
import { round } from '@/utils'
const { mapActions: mapAccountingActions, mapState: mapAccountingStates } = createNamespacedHelpers('Accounting')
const {mapActions: mapSystemActions } = createNamespacedHelpers('System')
const { mapState: mapMasterStates } = createNamespacedHelpers('Master')

export default {
  components: {
    ImportExcel,
    vSelect,
    CardDownloadTemplate: () => import('@/components/shared/card/CardDownloadTemplate.vue')
  },
  data () {
    return {
      form: [],
      importType: { label: 'Contracts',  value: 'Contracts' },
      maxItems: 10,
      state: 'null',
      meta: {},
      tableData: [],
      header: [],
      result: [],
      importId: "",
      error: false,
      errorMsg: "",
    }
  },
  filters: {
    resultStatus: function(res) {
      if(res.success){
        return "Success"
      }else{
        return "Error"
      }
    }
  },
  async created() {
    this.pms ('AccountingImport', 'visible', 'r')
  },
  computed: {
    ...mapAccountingStates(['status']),
    ...mapMasterStates(['loanTypes', 'interestTypes', "actionTypes"]),
    ...mapGetters({
      importAccountingTypesOptions :'Master/importAccountingTypesOptions',
    }),
  },
  methods: {
    ...mapAccountingActions([
    'importContracts',
    'importLoanDetails',
    'importLoanDetailPlans',
    'importPayments',
    'importTrackDownDebts',
    'importContractsSureties',
    'importBadDebts',
    ]),
    ...mapSystemActions(['deleteImportLog']),
    loadDataInTable ({ results, header, meta }) {
      this.header = header
      this.tableData = results
      this.meta = { fileName: meta.fileName}
      this.state = 'list'
      this.importType = {
        label: meta.importType,
        value: meta.importType
      }
      if(this.importType.value === "PaymentsByDebtorCard"){
        this.reportDatas = _(results)
        .groupBy('name')
        .map((objs, key) => {
            return {
                'name': key,
                'contractNo': objs[0].contractNo,
                'paymentAmount': _.sumBy(objs, 'paymentAmount'),
                'count': objs.length
            }
        })
        .value();
      }else if(this.importType.value === "ContractsInterestRateEir"){
        this.reportDatas = results.map(result =>{
          return {
            'ContractNo': result.ContractNo,
            'InterestRateEir': round(result.InterestRateEir*100, 2),
          }
        })
        this.tableData = this.reportDatas
      }
    },
    convBoolean (value) {
      try {
        return (value === "T")
      } catch (error) {
        return false
      }
    },
    convStr (value) {
        try {
          return value.toString().trim()
        } catch (error) {
          return "-"
        }
    },
    convInt (value) {
        try {
          return parseInt(value)
        } catch (error) {
          return 0
        }
    },
    convFloat (value) {
        try {
          return parseFloat(value)
        } catch (error) {
          return 0
        }
    },
    convType (type, args) {
      try {
        if(type === "LoanType"){
          const res = this.loanTypes.find(loanType => loanType.id === parseInt(args.id))
          if(res){
            return res.value
          }else{
            return "Null"
          }
        }else if(type === "transactionTypes"){
          const res = this.transactionTypes.find(transactionType => transactionType.value === args.value)
          if(res){
            return res.value
          }else{
            return "Close"
          }
        } else if(type === "LastCalculate"){
          if( args.value !== "-" ){
            return args.value
          }else{
            return "Null"
          }
        } else if(type === "InterestType"){
          const res = this.interestTypes.find(interestType => interestType.id === parseInt(args.id))
          if(res){
            return res.value
          }else{
            this.error = true;
            this.errorMsg = "กำหนด interestType  หรือ penaltyType ไม่ถูกต้อง"
            throw this.errorMsg;
          }
        } else if(type === "LoanDetailType"){
          let loanDetailType = "TuitionFee"
          if(parseInt(args.id) === 0) loanDetailType = 'TuitionFee'
          else if(parseInt(args.id) === 1) loanDetailType = 'CostOfLiving'
          return loanDetailType
        }
      } catch (error) {
        return "Null"
      }
    },
    convObj (type, args) {
      try {
        if (type === "loanDetails"){
          if(args.obj !== "-"){
            const data = []
            const objs = args.obj.split("|")
            let index = 0
            for (const obj of objs) {
              const countOpen = (obj.match(/{/g) || []).length;
              const countClose = (obj.match(/}/g) || []).length;
              if(countOpen !== 1) {
                this.error = true;
                this.errorMsg = "error open bracket: (" + obj + ")"
                throw this.errorMsg;
              }else if(countClose !== 1) {
                this.error = true;
                this.errorMsg = "error close bracket: (" + obj + ")"
                throw this.errorMsg;
              }
              const arr = obj.trim().replace(/[{}]/g,'').split(",");
              let loanDetailType = "-"
              if(parseInt(arr[0]) === 0) loanDetailType = 'TuitionFee'
              else if(parseInt(arr[0]) === 1) loanDetailType = 'CostOfLiving'
              data.push({
                seq: ++index,
                loanDetailType,
                loanDate: arr[1].toString(),
                amount: parseFloat(arr[2])
              })
            }
            return data
          }else {
            return []
          }
        } else if (type === "principlePeriodObjs"){
          const data = []
          let { principlePeriods, principleAmounts } = args;
          principlePeriods = principlePeriods.toString().split("|");
          principleAmounts = principleAmounts.toString().split("|");

          let index = 0
          for (const principlePeriod of principlePeriods) {
            data.push({
              seq: (index+1),
              principlePeriod: parseInt(principlePeriod),
              principleAmount: parseFloat(principleAmounts[index])
            })
            index++
          }
          return data
        } else if (type === "suretyDetails"){
          let data = []
          const idCardNumbers = args.objIdCardNumber.toString().split(",")
          const relationships = args.objRelationship.match(/"([^"]+)"/g).map(item => item.replace(/"/g, ''));
          if(idCardNumbers.length !== relationships.length){
            this.error = true;
            this.errorMsg = "error idCardNumbers and relationships length"
            throw this.errorMsg;
          }
          let index = 0
          for (const idCardNumber of idCardNumbers) {
            data.push({
              surety: { idCardNumber: idCardNumber },
              seq: (index+1),
              relationship: {
                nameTh: relationships[index]
              }
            })
            index++
          }
          return data
        }
      } catch (error) {
        return []
      }
    },
    async funcImportContract(action){
      const vm = this
      vm.error = false
      vm.errorMsg = "";

      let form = this.tableData.map(res => {
        if(res["ContractFee"]){
          vm.error = true
          vm.errorMsg = "ไม่สามารถกำหนด ContractFee ได้ กรุณาตรวจสอบ หรือโหลดไฟล์ใหม่"
        }else if(res["TaxAmount"]){
          vm.error = true
          vm.errorMsg = "ไม่สามารถกำหนด TaxAmount ได้ กรุณาตรวจสอบ หรือโหลดไฟล์ใหม่"
        }
        return {
          contractDate: vm.convStr(res["ContractDate"]),
          contractName: vm.convStr(res["ContractName"]),
          borrower: {
            idCardNumber: vm.convStr(res["Borrower"])
          },
          contractAmount: vm.convFloat(res["ContractAmount"]),
          contractAmountText: vm.convStr(res["ContractAmountText"]),
          curriculum: {
            curriculumNo : vm.convStr(res["CurriculumNo"])
          },
          periodTermStart: vm.convStr(res["PeriodBegin"]).split('/')[0].toString(),
          periodYearStart: parseInt(vm.convStr(res["PeriodBegin"]).split('/')[1]) + 543,
          periodTermEnd: vm.convStr(res["PeriodEnd"]).split('/')[0].toString(),
          periodYearEnd: parseInt(vm.convStr(res["PeriodEnd"]).split('/')[1]) + 543,
          forecastDate: vm.convStr(res["ForecastDate"]),
          loan:{
            loanType: vm.convType("LoanType", {id: res["LoanType"]}),
            interestType: vm.convType("InterestType", {id: res["InterestType"]}),
            interestRate: vm.convInt(res["InterestRate"]),
            penaltyType: vm.convType("InterestType", {id: res["PenaltyType"]}),
            penaltyRate: vm.convInt(res["PenaltyRate"]),
            period: vm.convInt(res["Period"]),
            paymentDue: vm.convStr(res["PaymentDue"]),
            paymentDescription: vm.convStr(res["PaymentDescription"]),
            loanDetails: vm.convObj("loanDetails", { obj: res["LoanDetails"] }),
            loanDetailPlans: vm.convObj("loanDetails", { obj: res["LoanDetailPlans"] })
          },
          paymentRoundsImport: {
            none: vm.convInt(res["NonePeriod"]),
            interest: vm.convInt(res["InterestPeriod"]),
            interestFixedPeriod: vm.convInt(res["InterestFixedPeriod"]),
            interestFixedAmount: vm.convFloat(res["InterestFixedPeriodAmount"]),
            principlePeriod: vm.convInt(res["PrinciplePeriod"]),
            principleAmount: vm.convFloat(res["PrinciplePeriodAmount"]),
          }
        }
      });

      if(this.error) {
        alert(this.errorMsg)
        throw this.errorMsg;
      }

      vm.$vs.loading()
      const { importContracts } = vm
      const result = await importContracts({
        action: action,
        meta: {...vm.meta, action: action},
        form,
        vm,
        redirect: null
      })
      if (action === "check") {
        vm.check = true
        vm.result = result
        vm.state = 'checked'
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      } else {
        vm.check = false
        vm.header = []
        vm.tableData = []
        vm.result = result
        vm.state = 'imported'
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }
    },
    async funcImportLoanDetails(action){
      const vm = this
      vm.error = false
      vm.errorMsg = "";
      let form = this.tableData.map(res => {
        return {
          contractNo: vm.convStr(res["ContractNo"]),
          loanDetailType: vm.convType("LoanDetailType", { id: res["Type"] }),
          loanDate: vm.convStr(res["LoanDate"]),
          amount: vm.convFloat(res["Amount"]),
          remark: vm.convStr(res["Remark"]),
          skipCheckDate: vm.convBoolean(res["SkipCheckDate"]),
        }
      });

      if(this.error) {
        alert(this.errorMsg)
        throw this.errorMsg;
      }

      vm.$vs.loading()
      const { importLoanDetails } = vm
      const result = await importLoanDetails({
        action: action,
        meta: {...vm.meta, action: action},
        form,
        vm,
        redirect: null
      })
      if(action === "check"){
        vm.check = true
        vm.result = result
        vm.state = 'checked'
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }else{
        vm.check = false
        vm.header = []
        vm.tableData = []
        vm.result = result
        vm.state = 'imported'
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }
    },
    async funcImportLoanDetailPlans(action){
      const vm = this
      vm.error = false
      vm.errorMsg = "";
      let form = this.tableData.map(res => {
        return {
          contractNo: vm.convStr(res["ContractNo"]),
          loanDetailType: vm.convType("LoanDetailType", { id: res["Type"] }),
          loanDate: vm.convStr(res["LoanDate"]),
          amount: vm.convFloat(res["Amount"]),
          remark: vm.convStr(res["Remark"]),
        }
      });

      if(this.error) {
        alert(this.errorMsg)
        throw this.errorMsg;
      }

      vm.$vs.loading()
      const { importLoanDetailPlans } = vm
      const result = await importLoanDetailPlans({
        action: action,
        meta: {...vm.meta, action: action},
        form,
        vm,
        redirect: null
      })
      if(action === "check"){
        vm.check = true
        vm.result = result
        vm.state = 'checked'
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }else{
        vm.check = false
        vm.header = []
        vm.tableData = []
        vm.result = result
        vm.state = 'imported'
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }
    },
    async funcImportPayments(action){
      const vm = this
      vm.error = false
      vm.errorMsg = "";
      let form = this.tableData.map(res => {
        return {
          loan: {
            contract: {
              contractNo: vm.convStr(res["ContractNo"]),
            }
          },
          receiveDate: vm.convStr(res["PaymentDate"]),
          paymentDate: vm.convStr(res["PaymentDate"]),
          paymentAmount: vm.convFloat(res["PaymentAmount"]),
          adjustment: vm.convBoolean(res["Adjustment"]),
          paymentRemark: vm.convStr(res["PaymentRemark"])
        }
      })

      if(this.error) {
        alert(this.errorMsg)
        throw this.errorMsg;
      }

      vm.$vs.loading()
      const { importPayments } = vm
      const result = await importPayments({
        action: action,
        meta: {...vm.meta, action: action},
        form,
        vm,
        redirect: null
      })
      if(action === "check"){
        vm.check = true
        vm.result = result
        vm.state = 'checked'
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }else{
        vm.check = false
        vm.header = []
        vm.tableData = []
        vm.result = result
        vm.state = 'imported'
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }
    },
    async funcImportTrackDownDebts(action){
      const vm = this
      vm.error = false
      vm.errorMsg = "";
      let form = this.tableData.map(res => {
        return {
          actionType: vm.convInt(res["ActionType"]),
          contractNo: vm.convStr(res["ContractNo"]),
          saveDate: vm.convStr(res["SaveDate"]),
          remark: vm.convStr(res["Remark"])
        }
      })


      if(this.error) {
        alert(this.errorMsg)
        throw this.errorMsg;
      }

      vm.$vs.loading()
      const { importTrackDownDebts } = vm
      const result = await importTrackDownDebts({
        action: action,
        meta: {...vm.meta, action: action},
        form,
        vm,
        redirect: null
      })
      if(action === "check"){
        vm.check = true
        vm.result = result
        vm.state = 'checked'
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }else{
        vm.check = false
        vm.header = []
        vm.tableData = []
        vm.result = result
        vm.state = 'imported'
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }
    },
    async funcImportContractsSureties(action){
      const vm = this
      vm.error = false
      vm.errorMsg = "";
      let form = this.tableData.map(res => {
        return {
          contractNo: vm.convStr(res["ContractNo"]),
          suretyDetails: vm.convObj("suretyDetails", { objIdCardNumber: res["IdCardNumber"], objRelationship: res["relationship"]})
        }
      });

      if(this.error) {
        alert(this.errorMsg)
        throw this.errorMsg;
      }

      vm.$vs.loading()
      const { importContractsSureties } = vm
      const result = await importContractsSureties({
        action: action,
        meta: {...vm.meta, action: action},
        form,
        vm,
        redirect: null
      });

      if(action === "check"){
        vm.check = true
        vm.result = result
        vm.state = 'checked'
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }else{
        vm.check = false
        vm.header = []
        vm.tableData = []
        vm.result = result
        vm.state = 'imported'
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }
    },
    async funcImportBadDebt(action){
      const vm = this
      vm.error = false
      vm.errorMsg = "";
      let form = this.tableData.map(res => {
        return {
          contractNo: vm.convStr(res["ContractNo"]),
          badDebtDate: vm.convStr(res["BadDebtDate"]),
          badDebtRemark: vm.convStr(res["BadDebtRemark"]),
        }
      })

      if(this.error) {
        alert(this.errorMsg)
        throw this.errorMsg;
      }

      vm.$vs.loading()
      const { importBadDebts } = vm
      const result = await importBadDebts({
        action: action,
        meta: {...vm.meta, action: action},
        form,
        vm,
        redirect: null
      })
      if(action === "check"){
        vm.check = true
        vm.result = result
        vm.state = 'checked'
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }else{
        vm.check = false
        vm.header = []
        vm.tableData = []
        vm.result = result
        vm.state = 'imported'
        setTimeout(() => {
          vm.$vs.loading.close()
        }, 150)
      }
    },
    async submit (action) {
      const vm = this
      const importType = vm.importType.value || vm.importType
      if(importType === "Contracts"){
        await vm.funcImportContract(action)
      } else if(importType === "LoanDetails"){
        await vm.funcImportLoanDetails(action)
      } else if(importType === "LoanDetailPlans"){
        await vm.funcImportLoanDetailPlans(action)
      } else if(importType === "Payments"){
        await vm.funcImportPayments(action)
      } else if(importType === "TrackDownDebts"){
        await vm.funcImportTrackDownDebts(action)
      } else if(importType === "ContractsSureties"){
        await vm.funcImportContractsSureties(action)
      } else if(importType === "BadDebts"){
        await vm.funcImportBadDebt(action)
      }
    },
    async del () {
      const vm = this
      vm.$vs.loading()
      const { deleteImportLog } = vm
      await deleteImportLog({
        form: {
          id: vm.importId
        },
        vm: vm
      })
      setTimeout(() => {
        vm.$vs.loading.close()
      }, 150)
    },
    async download(){
      const headerTitle = [
        'ชื่อ',
        'เลขที่สัญญา',
        'รวมชำระ',
        'จำรวนรอบชำระ',
      ]
      const headerVal = [
        'name',
        'contractNo',
        'paymentAmount',
        'count',
      ]
      const wscols = [
        {wch:20},{wch:20},{wch:20},{wch:10}
      ]

      import('@/vendor/Export2Excel').then(async excel => {
        const data = this.formatJson(headerVal, this.reportDatas)
        const vm = this
        excel.export_json_to_excel({
          header: headerTitle,
          data,
          filename: `${vm.meta.fileName} ${moment().format("YYYYMMDDhhmmss")}`,
          autoWidth: false,
          bookType: "xlsx",
          wscols: wscols
        })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map((res) => filterVal.map(col => {
        if(col === 'name'){
          return res[col]
        } else {
          return res[col]
        }
      }))
    }
  }
}
</script>
